import { render, staticRenderFns } from "./AdditionalCard.vue?vue&type=template&id=4dfa5b22&scoped=true&"
import script from "./AdditionalCard.vue?vue&type=script&lang=js&"
export * from "./AdditionalCard.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalCard.vue?vue&type=style&index=0&id=4dfa5b22&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dfa5b22",
  null
  
)

export default component.exports